module.exports = __webpack_public_path__ + "img/bottoomStepsImg.8c583785.png";